import { getEnv } from '../environment';
import request from './request';

const { REACT_APP_STORE_FRONT_API_URL: storeFront } = getEnv();

export const RECOMMENDATION_API_URL = (
  leadUuid: string,
  cta?: string,
  device?: string,
  anonymousId?: string,
  countryIsoCode = 'US',
) => {
  const url = `${storeFront}/personalized/recommendations/lead-uuid/${leadUuid}?countryIsoCode=${countryIsoCode}&campaignType=CUSTOMIZE`;

  const params = new URLSearchParams({
    ...(cta && { cta }),
    ...(device && { device }),
    ...(anonymousId && { anonymousId }),
  });

  return `${url}&${params.toString()}`;
};

export interface RecommendationProduct {
  badges: string[];
  brandName: string;
  currentStock: number;
  optionId: number;
  productName: string;
  psProductId: number;
  questionId: number;
  rating: number;
  retailPrice: number;
  score: number;
  sku: string;
  thumbnailUrl: string;
}

export interface RecommendationsApiResponse {
  campaignType: string;
  otherProducts: RecommendationProduct[];
  personalizedRecommendations: RecommendationProduct[];
}

interface GetRecommendationsParams {
  leadUuid: string;
  cta?: string;
  device?: string;
  anonymousId?: string;
  countryIsoCode?: string;
}

export const getRecommendations = async ({
  leadUuid,
  anonymousId,
  cta,
  device,
  countryIsoCode,
}: GetRecommendationsParams): Promise<RecommendationsApiResponse> =>
  request({
    path: RECOMMENDATION_API_URL(leadUuid, cta, device, anonymousId, countryIsoCode),
  });
